webpackJsonp([0],{

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("178c8ed0", content, true);

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".auth-bg[data-v-750f45b4]{position:relative;height:4rem;margin-bottom:.53333rem;background:-webkit-linear-gradient(left bottom,#e98a8b,#e26869);background:linear-gradient(to right top,#e98a8b,#e26869)}.auth-bg>p[data-v-750f45b4]{position:absolute;bottom:.42667rem;width:100%;margin:0 auto;color:#fff;font-size:16px;text-align:center}.icon[data-v-750f45b4]{position:absolute;left:50%;bottom:1.06667rem;margin-left:-.8rem}", "", {"version":3,"sources":["/opt/build/repo/src/views/auth/Auth.vue"],"names":[],"mappings":"AACA,0BACE,kBAAmB,AACnB,YAAa,AACb,wBAA0B,AAC1B,gEAAmE,AACnE,wDAA4D,CAC7D,AACD,4BACE,kBAAmB,AACnB,iBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,WAAY,AACZ,eAAgB,AAChB,iBAAmB,CACpB,AACD,uBACE,kBAAmB,AACnB,SAAU,AACV,kBAAmB,AACnB,kBAAqB,CACtB","file":"Auth.vue","sourcesContent":["\n.auth-bg[data-v-750f45b4] {\n  position: relative;\n  height: 4rem;\n  margin-bottom: 0.53333rem;\n  background: -webkit-linear-gradient(left bottom, #e98a8b, #e26869);\n  background: linear-gradient(to right top, #e98a8b, #e26869);\n}\n.auth-bg > p[data-v-750f45b4] {\n  position: absolute;\n  bottom: 0.42667rem;\n  width: 100%;\n  margin: 0 auto;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n}\n.icon[data-v-750f45b4] {\n  position: absolute;\n  left: 50%;\n  bottom: 1.06667rem;\n  margin-left: -0.8rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Register_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_0__Login_vue___default.a, Register: __WEBPACK_IMPORTED_MODULE_1__Register_vue___default.a
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leancloud_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(28);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      submitted: false
    };
  },

  validators: {
    username: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(v).required('用户名必填');
      }
    },
    password: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(v).required('密码必填');
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['updateUserFromAV']), {
    login: function login() {
      var _this = this;

      this.submitted = true;
      this.$validate().then(function (isSuccess) {
        if (isSuccess) {
          __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default.a.User.logIn(_this.username, _this.password).then(function (loginedUser) {
            _this.updateUserFromAV(loginedUser);
            Object(__WEBPACK_IMPORTED_MODULE_4__store__["b" /* fetchUserData */])();
            _this.$router.push('/');
          }).catch(function (error) {
            if (error.code === 1) {
              _this.$toast(error.error || '失败次数超出限制');
            } else if (error.code === 210) {
              _this.$toast('密码不正确');
            } else if (error.code === 211) {
              _this.$toast('用户不存在');
            }
            console.log(error);
          });
        }
      }).catch(function () {});
    }
  })
});

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "name": "username",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }, [(_vm.validation.hasError('username')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('username')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "name": "password",
      "tabindex": "2"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [(_vm.validation.hasError('password')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('password')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("登录")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leancloud_storage__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      repeat: '',
      submitted: false
    };
  },

  validators: {
    username: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(v).required('用户名必填').minLength(6, '至少6位以上的用户名');
      }
    },
    password: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(v).required('密码必填').minLength(6, '至少6位以上的密码');
      }
    },
    'repeat, password': {
      debounce: 300,
      validator: function validator(repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(repeat).required('请再次输入密码').match(password, '两次密码不一致');
        }
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['updateUserFromAV']), {
    register: function register() {
      var _this = this;

      this.submitted = true;
      this.$validate().then(function (isSuccess) {
        if (isSuccess) {
          var user = new __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default.a.User();
          user.setUsername(_this.username);
          user.setPassword(_this.password);
          user.signUp().then(function (loginedUser) {
            _this.updateUserFromAV(loginedUser);
            _this.$toast('恭喜您注册成功');
            _this.$router.push('/');
          }).catch(function (error) {
            if (error.code === 202) {
              _this.$toast('该用户名已被注册');
            }
            console.log(error);
          });
        }
      }).catch(function () {});
    }
  })
});

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }, [(_vm.validation.hasError('username')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('username')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "tabindex": "2"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [(_vm.validation.hasError('password')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('password')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "再次输入密码",
      "tabindex": "3"
    },
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = $$v
      },
      expression: "repeat"
    }
  }, [(_vm.validation.hasError('repeat')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('repeat')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("注册")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1 flex-column"
  }, [_c('div', {
    staticClass: "auth-bg"
  }, [_c('p', [_vm._v("身份认证")]), _vm._v(" "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "width": "60",
      "height": "60",
      "viewBox": "0,0,120,120"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M60,120 C27,120 0,93 0,60 C0,27 27,0 60,0 C93,0 120,27 120,60 C120,93 93,120 60,120 L60,120 Z M60,3 C28.5,3 3,28.5 3,60 C3,91.5 28.5,117 60,117 C91.5,117 117,91.5 117,60 C117,28.5 91.5,3 60,3 L60,3 Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M103.8,98.7 C103.8,98.7 90.6,85.8 72,81 L70.8,80.7 L70.8,79.5 C70.8,79.2 70.8,69.9 73.2,64.8 C73.8,63.6 74.7,62.4 75.6,61.2 C77.7,58.2 80.1,54.6 79.5,52.2 C79.2,51.3 78.9,50.7 77.7,50.4 L76.5,49.8 L77.1,48.6 C77.1,48.6 83.1,35.7 78,27.9 C75,23.4 69,21 60,21 C51,21 45,23.4 42,27.9 C36.9,36 42.9,48.6 42.9,48.6 L43.5,49.8 L42.3,50.4 C41.4,51 40.8,51.6 40.5,52.2 C39.9,54.6 42.3,58.2 44.4,61.2 C45.3,62.4 46.2,63.9 46.8,64.8 C49.2,69.6 49.2,78.9 49.2,79.5 L49.2,80.7 L48,81 C29.4,85.8 16.5,98.4 16.2,98.7 L14.1,96.6 C14.7,96 27.3,83.7 45.9,78.6 C45.9,76.2 45.6,69.9 43.8,66.6 C43.2,65.7 42.6,64.5 41.7,63.3 C39.3,59.7 36.6,55.5 37.5,51.9 C37.8,50.7 38.4,49.8 39.6,48.9 C38.1,45.3 34.5,34.2 39.3,26.4 C42.9,21 49.8,18 59.7,18 C69.9,18 76.8,20.7 80.1,26.4 C85.2,34.2 81.3,45.3 79.8,48.9 C80.7,49.8 81.6,50.7 81.9,51.9 C82.8,55.5 80.1,59.7 77.7,63.3 C76.8,64.5 76.2,65.7 75.6,66.6 C73.8,69.9 73.8,76.2 73.5,78.6 C92.1,83.7 105,96 105.3,96.6 L103.8,98.7 L103.8,98.7 Z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('u-tabs', {
    attrs: {
      "value": _vm.$route.path
    },
    on: {
      "change": function (v) { return _vm.$router.push(v); }
    }
  }, [_c('u-tab', {
    attrs: {
      "label": "登录",
      "value": "/auth/login"
    }
  }, [_c('login')], 1), _vm._v(" "), _c('u-tab', {
    attrs: {
      "label": "注册",
      "value": "/auth/register"
    }
  }, [_c('register')], 1)], 1), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v("忘记密码？")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(264),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-750f45b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.a3ca8f43db81347a1acf.js